import React, { useEffect, useState } from "react";
import { Button, Input, Panel } from "rsuite";
import { Image } from "react-bootstrap";

export const Nefrosys = () => {
  const [telefono] = useState("4442560850");
  const [message, setMessage] = useState("Hola");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
  };

  const constructMessage = (e) => {
    setMessage(
      `Hola mi nombre es ${e}, me encuentro interesado en la plataforma.`,
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };

    window.addEventListener("resize", handleResize);
    setTimeout(() => {
      window.location = `/#/App`;
    }, 1500);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []);

  const classContainer = {
    display: "flex" /* Enables Flexbox */,
    justifyContent: "center" /* Centers horizontally */,
    alignItems: "center" /* Centers vertically */,
    height: "100vh" /* Makes container full viewport height */,
    width: "100%",
    backgroundColor: "#f0f0f0" /* Optional: background for the cover area */,
  };

  const imageStyle = {
    display: "block",
    marginLeft: "auto" /* Pushes image to center from left */,
    marginRight: "auto",
    marginTop: "15px" /* Manual top margin */,
    maxWidth: "90%" /* Prevents image from touching sides */,
    borderRadius: "10px",
  };

  return (
    <>
      <div style={classContainer}>
        <Image src="/Images/Logo.png" style={imageStyle}></Image>
      </div>
      <div>
        <center><h2>Iniciando...</h2></center>
      </div>
    </>
  );
};
